import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import axios from "axios";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker, Form, InputNumber, Modal } from "antd";
import { axiosErrorHandler } from "../../../../swzutils";
import { isUserMultiTenant } from "../../../../swzutils/UserPermissionsUtil";
import TenantSelect from "../../components/TenantSelect";
import { loggedInUserSelector } from "../../../../store/slice/auth";
import { useAppSelector } from "../../../../store";
const FuelLevyCreateModal = ({ open, onSuccess, onCancel }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const save = (formValues) => {
        setLoading(true);
        const request = {
            tenantId: formValues.tenantId,
            effectiveFrom: formValues.effectiveFrom,
            effectiveTo: formValues.effectiveTo,
            levyPercent: formValues.levyPercent / 100
        };
        axios.post(`/admin/v1/fuel-levies`, request)
            .then((response) => onSuccess(response.data))
            .catch(axiosErrorHandler)
            .finally(() => setLoading(false));
    };
    const disableBeforeToday = (selectedDate) => {
        return selectedDate && selectedDate < dayjs().startOf('day');
    };
    return (_jsx(Modal, { title: "Create a Fuel Levy", open: open, onOk: form.submit, onCancel: onCancel, confirmLoading: loading, destroyOnHidden: true, children: _jsxs(Form, { layout: "vertical", onFinish: save, form: form, children: [isUserMultiTenant(loggedInUser) &&
                    _jsx(Form.Item, { name: "tenantId", label: "Profile", style: { paddingBottom: '15px' }, help: "Leave blank to create a global fuel levy applicable to all tenants", children: _jsx(TenantSelect, { allowClear: true }) }), _jsx(Form.Item, { name: "effectiveFrom", label: "Effective From", rules: [{
                            required: true,
                            message: 'Please a date and time ',
                        }], children: _jsx(DatePicker, { disabledDate: disableBeforeToday, showTime: true, showNow: false, presets: [
                            { label: 'Midnight Tonight', value: dayjs().add(1, 'day').hour(0).minute(0).second(0) }
                        ], format: "DD/MM/YYYY HH:mm", style: {
                            width: "100%"
                        }, minuteStep: 5 }) }), _jsx(Form.Item, { name: "effectiveTo", label: "Effective To", rules: [
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (value == null) {
                                    return Promise.resolve();
                                }
                                const effectiveFrom = getFieldValue('effectiveFrom');
                                if (!effectiveFrom || effectiveFrom.isBefore(value)) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('Effective to date should be after effective from date'));
                            },
                        }),
                    ], children: _jsx(DatePicker, { disabledDate: disableBeforeToday, showTime: true, showNow: false, format: "DD/MM/YYYY HH:mm", style: {
                            width: "100%"
                        }, minuteStep: 5 }) }), _jsx(Form.Item, { name: "levyPercent", label: "Percentage", rules: [
                        { required: true, message: 'Please enter a percentage' }
                    ], children: _jsx(InputNumber, { min: 0, max: 99, step: 1 }) })] }) }));
};
export default FuelLevyCreateModal;
